// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import HelloController from "./hello_controller.js"
application.register("hello", HelloController)

import PharmacyController from "./pharmacy_controller.js"
application.register("pharmacy", PharmacyController)

import * as bootstrap from "bootstrap"

// Import from UMD bundle instead of ES module
import Reveal from "stimulus-reveal-controller/dist/stimulus-reveal-controller.umd"
application.register("reveal", Reveal)